const RewardsTrue = ({ className }: { className: string }) => (
  <svg
    width="26"
    height="23"
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24.2101 0.481161C23.3358 -0.267921 22.0112 -0.12599 21.3154 0.791324L10.0303 15.6697L4.01417 9.65793C3.23304 8.87737 1.9671 8.87759 1.18625 9.65844L0.585599 10.2591C-0.195449 11.0401 -0.195448 12.3065 0.5856 13.0875L8.99626 21.4982C9.84688 22.3488 11.2505 22.2615 11.9891 21.3119L25.4288 4.03434C26.0844 3.1915 25.9622 1.9823 25.1514 1.28757L24.2101 0.481161Z"
      fill="currentColor"
    />
  </svg>
)

export default RewardsTrue
